import { Controller } from "@hotwired/stimulus";

const DEDUCTION_ONLY_KEYWORDS = ["年末調整", "前月調整", "過不足", "年調"];

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.toast = null;
    this.validate();
  }

  validate() {
    let hasWarning = false;
    let matchedKeyword = null;

    this.inputTargets.forEach((input) => {
      if (input.readOnly) return;

      const value = input.value;
      const keyword = DEDUCTION_ONLY_KEYWORDS.find((k) => value.includes(k));
      if (keyword) {
        input.classList.add("deduction-warning");
        hasWarning = true;
        if (!matchedKeyword) matchedKeyword = keyword;
      } else {
        input.classList.remove("deduction-warning");
      }
    });

    this.toggleToast(hasWarning, matchedKeyword);
  }

  toggleToast(show, keyword) {
    if (show) {
      if (!this.toast) {
        this.toast = document.createElement("div");
        this.toast.className = "deduction-warning-toast";
        document.body.appendChild(this.toast);
      }
      this.toast.textContent =
        `「${keyword}」は支給項目ではなく控除項目に設定してください。支給項目に設定すると雇用保険・所得税の計算に影響します。`;
    } else if (this.toast) {
      this.toast.remove();
      this.toast = null;
    }
  }

  disconnect() {
    if (this.toast) {
      this.toast.remove();
      this.toast = null;
    }
  }
}
